import styled from 'styled-components'

export const TextAndMathEditorContainer = styled.div`
  width: 100%;

  span.input__math__field {
    border: none;
  }

  span.input__math[data-latex^='\\\\frac{+'],
  span.input__math[data-latex^='\\\\frac{-'],
  span.input__math[data-latex^='\\\\frac{\\\\times'] {
    .mq-fraction .mq-numerator .mq-fraction .mq-denominator {
      border-top: none;
      margin-top: 2px;
    }
  }

  span.input__math[data-latex^='\\\\class{math-editor-stacked-fractions-exponents}{\\\\frac{\\\\left'] {
    .mq-paren {
      display: none;
    }
  }

  .mq-empty:not(:empty) {
    background: none !important;
  }
`
export const TextAndMathEditorToolbar = styled.div`
  display: flex;
  width: 100%;
  min-height: 38px;
  align-content: center;
  justify-content: space-between;
  align-items: stretch;
  background-color: #334049;
  padding: 10px 12px;
  margin-bottom: 8px;
  flex-wrap: wrap;
  gap: 8px;
  border-bottom: 1px solid #858585;
  border-top: 1px solid #858585;
  border-top-left-radius: 4px;
`

export const TextAndMathEditorToolbarButtons = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
`
export const TextAndMathEditorToolbarButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px;
  border: none;
  background: transparent;
  color: #ffffff;
  cursor: pointer;
  transition: all 0.15s ease;
  width: 34px;
  height: 34px;
  &:hover {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 3px;
  }
  &:active {
    background: rgba(255, 255, 255, 0.2);
    border-radius: 3px;
  }
`
